module.exports = __webpack_public_path__ + "img/img-ca1ab2aa.57dca916.png";